module.exports = __webpack_public_path__ + "static/media/Digital Health  - Graphic.02e460d9.svg";